import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ObterUltimaEdicaoECalendarioState } from '../../reducers/Jornal/obter-ultima-edicao-e-calendario-para-home.reducer';

export const selectObterUltimaEdicaoECalendarioState = createFeatureSelector<ObterUltimaEdicaoECalendarioState>('obterUltimaEdicaoECalendario');

export const selectDadosObterUltimaEdicaoECalendario = createSelector(
  selectObterUltimaEdicaoECalendarioState,
  (state: ObterUltimaEdicaoECalendarioState) => state.response
);

export const selectErrosObterUltimaEdicaoECalendario = createSelector(
  selectObterUltimaEdicaoECalendarioState,
  (state: ObterUltimaEdicaoECalendarioState) => state.error
);
